import { useCallback, useState } from 'react';
import olreadiaService, { BusinessLocationType } from '../services/olreadiaService';

const toMessage = (err: any, fallback: string) =>
  err?.response?.data?.message || err?.message || fallback;

export const useBusinessLocationTypes = () => {
  const [locationTypes, setLocationTypes] = useState<BusinessLocationType[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLocationTypes = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await olreadiaService.businessLocationTypes.list(params);
      const content = Array.isArray(res?.content) ? res.content : [];
      setLocationTypes(content);
      return content;
    } catch (err) {
      const message = toMessage(err, 'Failed to load business location types');
      setError(message);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return { locationTypes, loading, error, fetchLocationTypes };
};

export default useBusinessLocationTypes;
